import * as React from "react";
import { Dismiss20Regular } from "@fluentui/react-icons";
import { ITab } from "../../types/ITab";
import TabComponent from "./TabComponent";
import { displayRepresentationFlag } from "../../../redux/reducers/RepertoireReducer";
import { ITabReduxItem } from "../../../redux/types/ITabReduxItem";
import { hideModal, showYesNoPrompt } from "../../../redux/reducers/ModalReducer";
import { INTRAY, DRAFT_SET_LISTS_MAINTENANCE_PAGE, DRAFT_AGREEMENTS_MAINTENANCE_PAGE, REPERTOIRE, REGISTERED_SET_LISTS_MAINTENANCE_PAGE, REGISTERED_AGREEMENTS_MAINTENANCE_PAGE }
    from "../../Consts";
import { IYesNoPromptViewModalProps } from "../../../repertoire/components/modalViews/yesNoPromptView/YesNoPromptView";
import { ALL_REGISTERED_WORKS_INTRAY_TAB_ICON, ALL_REGISTERED_WORKS_INTRAY_TAB_ICON_TRANSFORM, ALL_REGISTERED_WORKS_REPERTOIRE_TAB_ICON, ALL_REGISTERED_WORKS_REPERTOIRE_TAB_ICON_TRANSFORM, REGISTERED_WORKS_INTRAY_TAB_ICON, REGISTERED_WORKS_INTRAY_TAB_ICON_TRANSFORM, REGISTERED_WORKS_REPERTOIRE_TAB_ICON, REGISTERED_WORKS_REPERTOIRE_TAB_ICON_TRANSFORM, DRAFT_WORK_INTRAY_TAB_ICON, DRAFT_WORK_INTRAY_TAB_ICON_TRANSFORM, DRAFT_WORK_REPERTOIRE_TAB_ICON, DRAFT_WORK_REPERTOIRE_TAB_ICON_TRANSFORM } from "../../../membersportal/Consts";
import CarouselScrollButton from "../../../repertoire/components/carouselScrollButton/CarouselScrollButton";
import { mp_removeTab } from "../../../redux/reducers/MembersPortalReducer";
import { CleanUploadFilesState } from "../../../redux/reducers/DataIngestionReducer";
import IMembersPortalComponentDataItem from "../../../redux/types/IMembersPortalComponentDataItem";
import { setCurrentPage } from "../../../redux/reducers/HomeReducer";
import { AGREEMENT_INTRAY_TAB_ICON, AGREEMENT_INTRAY_TAB_ICON_TRANSFORM, AGREEMENT_REPERTOIRE_TAB_ICON, AGREEMENT_REPERTOIRE_TAB_ICON_TRANSFORM } from "../../../repertoire/Consts";
import { MEMBERS_PORTAL } from "../../../accounts/Consts";
import { ErrorBoundary } from "../../../telemetry/components/ErrorBoundary";
import { IMenuItem } from "../../../core/types/IMenuItem";

export interface ITabsViewProps {
    tabs: ITabReduxItem[];
    tabsViewData: IMembersPortalComponentDataItem;
    removeTab: typeof mp_removeTab;
    activeTab: number;
    openTab: (index: number) => void;
    closeTabDisabled: boolean;
    hideModal?: typeof hideModal;
    showYesNoPrompt?: typeof showYesNoPrompt;
    displayRepresentation: typeof displayRepresentationFlag;
    setCurrentPage: typeof setCurrentPage;
    portalType: string;
    cleanUploadFilesState: typeof CleanUploadFilesState;
    menuItems: IMenuItem[];
}

export default class TabsView extends React.PureComponent<ITabsViewProps, {}> {
    constructor(props: ITabsViewProps) {
        super(props);
    }

    onClickRemoveTab = (index: number) => {
        const { removeTab, tabs, closeTabDisabled, tabsViewData,
            hideModal, showYesNoPrompt, cleanUploadFilesState } = this.props;
        if (closeTabDisabled) {
            return;
        }

        if (tabs[index].changesMade) {
            const message: string = tabsViewData.fields[0]?.data ?? '';
            const modalHeader : string = tabsViewData.fields.find(f => f.name == "tabsViewModalHeader")?.data ?? 'Leave Page?';
            const props: IYesNoPromptViewModalProps = {
                yesCallback: () => {
                    if (tabs[index].component == 'LivePerformanceMaintenancePage') cleanUploadFilesState();

                    removeTab(index);
                    hideModal();
                },
                noCallback: () => { hideModal(); }
            }
            showYesNoPrompt(modalHeader, props, undefined, message);
        } else { 
            if (tabs[index].component == 'LivePerformanceMaintenancePage') cleanUploadFilesState();

            removeTab(index);
        }
    }

    componentDidMount() {
        this.updateHeaderForActiveTab();
    }

    componentDidUpdate(prevProps: ITabsViewProps) {
        const previousTab = prevProps.tabs[prevProps.activeTab];
        const currentTab = this.props.tabs[this.props.activeTab];

        if (previousTab !== currentTab || prevProps.menuItems !== this.props.menuItems) {
            this.updateHeaderForActiveTab();
        }

        if (prevProps.activeTab !== this.props.activeTab) {
            window.scrollTo({ top: 0, behavior: "auto" });

            const tabContent = document.querySelector(".tab-content");
            if (tabContent) {
                (tabContent as HTMLElement).scrollTop = 0;
            }
        }
    }

    updateHeaderForActiveTab = () => {
        const { menuItems, setCurrentPage, tabs, activeTab } = this.props;
        const tab = tabs[activeTab];
        const menuName = tab?.name ?? (tab?.component === "MyPackagesPage" ? "myPackages" : undefined);
        if (!menuName || !menuItems?.length) {
            return;
        }

        const flattenedMenuItems: IMenuItem[] = [];
        menuItems.forEach(item => {
            flattenedMenuItems.push(item);
            item.children?.forEach(child => flattenedMenuItems.push(child));
        });

        const menuItem = flattenedMenuItems.find(item => item.name === menuName)
            ?? (tab.component === "MyPackagesPage"
                ? flattenedMenuItems.find(item => item.link?.toLowerCase().endsWith("/mypackages"))
                : undefined);
        if (!menuItem?.link) {
            return;
        }

        setCurrentPage(menuItem.link);
        document.title = menuItem.label;
    }

    async onClick(target, index) {
        const { tabsViewData } = this.props;

        const componentName = this.props.tabs[index]?.component;
        const remove = document.getElementsByClassName("tabCloseIcon");
        if (remove[index]?.contains(target)) {
            await this.onClickRemoveTab(index);
        } else {
            await this.props.openTab(index);
        }

        const title = tabsViewData?.fields?.find(f => f.name == componentName)?.data ?? tabsViewData?.fields?.find(f => f.name == "untitled")?.data ?? document.title;
        document.title = title;
    }

    getTabName = (tabsViewData: IMembersPortalComponentDataItem, index: number) => {
        const { tabs } = this.props;
        const copyOfPrefix = tabsViewData.fields.find(f => f.name == "copyOf")?.data;
        const tab = tabs[index];
        const prevTab = tabs[index - 1];

        let tabTitle = tabsViewData.fields.find(f => f.name == 'untitled')?.data ?? 'Untitled';

        if (tab.draftWorkMaintenanceState && tab.draftWorkMaintenanceState.work){
            if (tab.draftWorkMaintenanceState.isNew) {
                tabTitle = tabsViewData.fields.find(f => f.name == "newDraftWork")?.data ?? tabTitle;

                if (tab.draftWorkMaintenanceState.isCopy) {
                    tabTitle = copyOfPrefix + (prevTab?.draftWorkMaintenanceState?.work?.workID > 0 ? prevTab.draftWorkMaintenanceState.work.workID : tabTitle.toLowerCase());
                }

                return tabTitle;
            }
            return tab.title ?? tabTitle;
        }
        else if (tab.agreementMaintenanceState && tab.agreementMaintenanceState.agreement){
            if (tab.agreementMaintenanceState.isNew) {
                tabTitle = tabsViewData.fields.find(f => f.name == "newDraftAgreement")?.data ?? tabTitle;
                return tabTitle;
            }
            return tab.title ?? tabTitle;
        }
        else if (tab.draftSetListsMaintenanceState && tab.draftSetListsMaintenanceState.setLists){
            if (tab.draftSetListsMaintenanceState.isNew) {
                tabTitle = tabsViewData.fields.find(f => f.name == "newDraftSetList")?.data ?? tabTitle;

                if (tab.draftSetListsMaintenanceState.isCopy) {
                    tabTitle = copyOfPrefix + (prevTab?.draftSetListsMaintenanceState?.setLists?.originalTitle ? prevTab.draftSetListsMaintenanceState.setLists.originalTitle : tabTitle.toLowerCase());
                }

                return tabTitle;
            }
            return tab.title ?? tabTitle;
        }
        else if ((tab.registeredWorkMaintenanceState && tab.registeredWorkMaintenanceState.work)
            || (tab.allRegisteredWorkMaintenanceState && tab.allRegisteredWorkMaintenanceState.work)
            || (tab.memberStatementWorkState && tab.memberStatementWorkState.distributionCode)
            || (tab.memberStatementUsageDetailsState && tab.memberStatementUsageDetailsState.workID)
            || (tab.memberStatementDetailsState && tab.memberStatementDetailsState.payment?.paymentRunCode)
            || (tab.cueSheetMaintenanceState && tab.cueSheetMaintenanceState.cueSheets)
            || (tab.livePerformanceMaintenanceState && tab.livePerformanceMaintenanceState.usageGroup)) {

            return tab.title ?? tabTitle;
        }

        return tabsViewData?.fields.find(f => f.name == tab.component)?.data ?? tabTitle;

    }

    renderTabs = () => {
        const { tabs, activeTab, closeTabDisabled, tabsViewData } = this.props;

        return tabs.map((tab: ITabReduxItem, index: number) => (
            <div onClick={(e) => this.onClick(e.target, index)} key={tab.tabId ?? index} className={activeTab === index ? "activeTab" : "tab"}>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 100 100">
                    {tabs[index].draftWorkMaintenanceState && tabs[index].draftWorkMaintenanceState.work ?
                        (tabs[index].draftWorkMaintenanceState.work.dataSource === INTRAY ?
                            <path id="" className="tabIconType" d={DRAFT_WORK_INTRAY_TAB_ICON} transform={DRAFT_WORK_INTRAY_TAB_ICON_TRANSFORM}></path>
                            : <path id="" className="tabIconType" d={DRAFT_WORK_REPERTOIRE_TAB_ICON} transform={DRAFT_WORK_REPERTOIRE_TAB_ICON_TRANSFORM}></path>)
                        : tabs[index].registeredWorkMaintenanceState && tabs[index].registeredWorkMaintenanceState.work ?
                            (tabs[index].registeredWorkMaintenanceState.work.dataSource === INTRAY ?
                                <path id="" className="tabIconType" d={REGISTERED_WORKS_INTRAY_TAB_ICON} transform={REGISTERED_WORKS_INTRAY_TAB_ICON_TRANSFORM}></path>
                                : <path id="" className="tabIconType" d={REGISTERED_WORKS_REPERTOIRE_TAB_ICON} transform={REGISTERED_WORKS_REPERTOIRE_TAB_ICON_TRANSFORM}></path>)
                            : tabs[index].allRegisteredWorkMaintenanceState && tabs[index].allRegisteredWorkMaintenanceState.work ?
                                (tabs[index].allRegisteredWorkMaintenanceState.work.dataSource === INTRAY ?
                                    <path id="" className="tabIconType" d={ALL_REGISTERED_WORKS_INTRAY_TAB_ICON} transform={ALL_REGISTERED_WORKS_INTRAY_TAB_ICON_TRANSFORM}></path>
                                    : <path id="" className="tabIconType" d={ALL_REGISTERED_WORKS_REPERTOIRE_TAB_ICON} transform={ALL_REGISTERED_WORKS_REPERTOIRE_TAB_ICON_TRANSFORM}></path>)
                                : tabs[index].agreementMaintenanceState && tabs[index].agreementMaintenanceState.agreement ?
                                (tabs[index].agreementMaintenanceState.agreement.dataSource === INTRAY ?
                                    <path id="" className="tabIconType" d={AGREEMENT_INTRAY_TAB_ICON} transform={AGREEMENT_INTRAY_TAB_ICON_TRANSFORM}></path>
                                    : <path id="" className="tabIconType" d={AGREEMENT_REPERTOIRE_TAB_ICON} transform={AGREEMENT_REPERTOIRE_TAB_ICON_TRANSFORM}></path>)
                                : <></>
                    }
                </svg>
                <div>
                    {this.getTabName(tabsViewData, index)}
                </div>
                <div
                    className={["removeTabDiv", !!closeTabDisabled && "closeDisabled"].join(" ")}
                >
                    <Dismiss20Regular className="tabCloseIcon" aria-hidden="true" />
                </div>
            </div>
        ));
    };

    renderTabContent = () => {
        const { tabs, displayRepresentation, activeTab } = this.props;
        return tabs.map((tab: ITabReduxItem, index: number) => {
            const stableKey = tab.tabId ?? `mp-tab-${index}-${tab.component}`;
            const isActive = activeTab === index;
            return (
                <div
                    key={stableKey}
                    role="tabpanel"
                    className={`tab-pane fade ${isActive ? 'in active' : ''} ${tab.isReadonly ? 'versionHistory' : ''}`}
                    style={{ display: isActive ? 'block' : 'none' }}
                >
                    <ErrorBoundary key={stableKey} pageName={tab.title}>
                        <TabComponent component={tab.component} displayRepresentation={displayRepresentation} tabId={tab.tabId} />
                    </ErrorBoundary>
                </div>
            );
        });
    };

    render() {
        const { tabsViewData } = this.props;

        if (!tabsViewData?.fields?.length) {
            return null;
        }

        return (
            <div className="form-group col-md-12 TabsView">
                <div className="tabsDiv">
                    <CarouselScrollButton
                        content={this.renderTabs()}
                        distanceToScroll={100}
                    />
                </div>
                <div
                    id="tab-container"
                    className="tab-content formBox tab-pane active fade in"
                >
                    {this.renderTabContent()}
                </div>
            </div>
        );
    }
}
